import React, { useState, useEffect, useContext } from 'react';
import Header from '../Header/AppHeader';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import Alert from 'react-s-alert';
import { ThemeContext } from '../Common/ThemeProvider';
import 'react-s-alert/dist/s-alert-default.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faHourglassEnd, faPen, faSignal, faSyncAlt, faRunning } from '@fortawesome/free-solid-svg-icons';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import axios from 'axios';
import FailureAlert from '../Common/Failure';
import Select from 'react-select';
import PhoneRing from '../../Images/PhoneRing.gif';
import { FetchActivatedUsers } from '../Common/Services/UserService';
import Loader from '../Common/Loader';
import DataTable from '../Common/DataTableList';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';

const TripDefault = {
    tel: "",
    eta_days: 0,
    srcname: "",
    destname: "",
    srcaddress: "",
    destaddress: "",
    vendor: "",
    truck_number: "",
    invoice: "",
    custom_Org: ""
};

const auth = {
    username: "AksDtUVhSF",
    password: "3rPfGsBZMi"
};

const ManageTrip = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [Trip, setTrip] = useState(TripDefault);
    const [TripsInfo, setTripsInfo] = useState([]);
    const [InvoicesInfo, setInvoicesInfo] = useState([]);
    const [InvoicesData, setInvoicesData] = useState([]);
    const [ConsentInfo, setConsentInfo] = useState({});
    const [UpdateTel, setUpdateTel] = useState("");
    const [SelectedTrip, setSelectedTrip] = useState("");
    const [displayAddTrip, setdisplayAddTrip] = useState("none");
    const [displayConsent, setdisplayConsent] = useState("none");
    const [displayUpdateTrip, setdisplayUpdateTrip] = useState("none");
    const [displayMobileAlert, setdisplayMobileAlert] = useState("none");
    const [PartnerUsers, setPartnerUsers] = useState([]);
    const [TrackingPartners, setTrackingPartners] = useState("");
    const [Loading, setLoading] = useState(false);

    useEffect(() => {
        FetchCustmers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columns = React.useMemo(
        () => [
            {
                name: 'SI #',
                width: "75px",
                selector: (row, index) => (index + 1),
                sortable: true,
            },
            {
                name: 'TripID',
                width: "225px",
                selector: row => row.Id ? <NavLink target="_blank" title="Click to see Tracking" rel="noopener noreferrer" to={`/TrackingDetails/${row.Id}`}>{row.Id}</NavLink> : "-",
                sortable: true,
            },
            {
                name: 'Origin',
                width: "150px",
                selector: row => {
                    return <div>
                        {row.sourceName}
                    </div>
                },
                sortable: true,
            },
            {
                name: 'Dest',
                width: "150px",
                selector: row => {
                    return <div style={{ whiteSpace: "normal", textAlign: "left" }}>
                        {row.destname}
                    </div>
                },
                sortable: true,
            },
            {
                name: 'Truck',
                width: "150px",
                selector: row => row.truck_number,
                sortable: true
            },
            {
                name: 'Origin Address',
                width: "250px",
                selector: row => {
                    return <div style={{ whiteSpace: "normal", textAlign: "left" }}>{row.srcaddress}</div>
                },
                sortable: true,
            },
            {
                name: 'Dest. Address',
                width: "250px",
                selector: row => {
                    return <div style={{ whiteSpace: "normal", textAlign: "left" }}>{row.destaddress}</div>
                },
                sortable: true,
            },
            {
                name: 'Phone',
                width: "135px",
                selector: row => {
                    return <div style={{
                        padding: "0 10px", borderRadius: "10px",
                        backgroundColor: "#1155ff", color: "white"
                    }}><a style={{ color: "white", textDecoration: "none" }} href={`tel:+91${row.TelePhone}`}>{row.TelePhone}</a></div>
                },
                sortable: true,
            },
            {
                name: 'Invoice',
                width: "150px",
                selector: row => !IsUndefinedNullOrEmpty(row.invoice) ? row.invoice : "-",
                sortable: true,
            },
            {
                name: 'LR',
                width: "150px",
                selector: row => {
                    return <div style={{ whiteSpace: "normal", textAlign: "left" }}>{!IsUndefinedNullOrEmpty(row.lr_number) ? row.lr_number : "-"}</div>
                },
                sortable: true,
            },
            {
                name: 'Created Date',
                width: "220px",
                selector: row => moment(row.CreatedDate).local().format("DD/MM/YYYY hh:mm:ss A"),
            },
            {
                name: 'status',
                selector: row => {
                    return <span title={row.status}>
                        <FontAwesomeIcon style={{ color: (row.endTime !== undefined ? "red" : "green") }} icon={faSignal} />
                    </span>
                }
            },
            {
                name: 'Actions',
                width: "150px",
                selector: row => {
                    return <div style={{ minWidth: "100px", fontSize: "20px" }}>
                        <span className="cursorpointer" title="Update Trip">
                            <FontAwesomeIcon style={{ color: "#147a6f" }} onClick={() => ShowUpdateTrip(row.Id, row.TelePhone)} icon={faPen} />
                        </span>
                        <span className="cursorpointer" title="End Trip" style={{ marginLeft: 15 }}>
                            <FontAwesomeIcon style={{ color: "#f61414" }} onClick={() => EndTrip(row.Id)} icon={faHourglassEnd} />
                        </span>
                    </div>
                }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        ], []
    );

    const FetchCustmers = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

        if (userData !== null) {
            Axiosfetch(baseURL + "GetActiveCustomersByPartnerID", "POST", {
                PartnerID: userData.OrganizationID,
                limit: 0,
                sorting: -1
            }, CustomerSuccess, Failure);
        }
    };

    const CustomerSuccess = (data) => {
        if (data.length > 0) {
            var customerData = [];
            setInvoicesData(data);
            data.forEach(customer => {
                if (customer.SurveyApproved === 1) {
                    customerData.push({ label: customer.SurveyID + "-" + moment(customer.createdAt).local().format("DDMMYYYY"), value: customer._id })
                }
            });

            // FetchTrips();
            setInvoicesInfo(customerData);
        }
        else {
            setInvoicesData([]);
            setInvoicesInfo([]);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
        setLoading(false);
    };

    const showTrip = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

        var TrackLogsCount = 0;
        var TrackLimit = 0;
        Axiosfetch(baseURL + "GetTrackLogsCountByOrg", "POST", {
            TrackBy: userData.Organization[0]._id
        }, (data) => {
            TrackLogsCount = data && data.data && data.data.Count ? data.data.Count : 0;
            Axiosfetch(baseURL + "GetActiveTrackLimitByOrgID", "POST", {
                OrgID: userData.Organization[0]._id
            }, (data) => {
                TrackLimit = data && data.length > 0 ? data[0].LimitCount : 0;
                if (TrackLimit >= TrackLogsCount) {
                    setdisplayAddTrip("block");
                    var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

                    if (userData !== null && userData.Organization && userData.Organization.length > 0) {
                        setTrip({ ...Trip, "vendor": "MFI " + userData.Organization[0].City });
                    }

                    FetchUsers();
                }
                else {
                    Alert.error("Tracking Limit Exceeded. Please contact Administrator", {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });
                }

            }, Failure);
        }, Failure);


    };

    const hideTrip = () => {
        setdisplayAddTrip("none");
    };

    const hideConsent = () => {
        setdisplayConsent("none");
    }

    const hideUpdateTrip = () => {
        setdisplayUpdateTrip("none");
    };

    const hideMobileAlert = () => {
        setdisplayMobileAlert("none");
    };

    const DisplayOperatorInfo = () => {
        setdisplayMobileAlert("block");
    };

    const onTextChange = (e) => {
        setTrip({ ...Trip, [e.target.name]: e.target.value });
    };

    const onTruckTextChange = (e) => {
        let data = e.target.value ? e.target.value.trim().toUpperCase() : "";
        data = data ? data.toUpperCase().split(" ").join("") : "";
        setTrip({ ...Trip, [e.target.name]: data });
    };

    const onNumberChange = (e) => {
        setTrip({ ...Trip, [e.target.name]: parseInt(e.target.value) });
    };

    const onUpdateTripChange = (e) => {
        setUpdateTel(e.target.value);
    };

    const ShowUpdateTrip = (tripID, telePhone) => {
        setSelectedTrip(tripID);
        setUpdateTel(telePhone);
        setdisplayUpdateTrip("block");
    };

    const StartTrip = async () => {
        setLoading(true);

        var isValid = await ValidateTrip();
        if (isValid) {
            const token = Buffer.from(`${auth.username}:${auth.password}`, 'utf8').toString('base64');
            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

            var tripstart = Trip;

            tripstart.custom_Org = TrackingPartners === "" ? userData.Organization[0]._id : `${TrackingPartners};${userData.Organization[0]._id}`;
            tripstart.TrackBy = userData.Organization[0]._id;

            await axios.post("https://sct.intutrack.com/api/" + ((process.env.REACT_APP_TRACK_ISPROD && process.env.REACT_APP_TRACK_ISPROD.toString() === "1") ? "prod" : "test") + "/trips/start", tripstart,
                {
                    headers: {
                        'crossdomain': true,
                        'Authorization': `Basic ${token}`
                    }
                }).then(async function (response) {
                    if (response.status === 200 && response.data.msg !== undefined) {
                        if (response.data.consentResults && response.data.consentResults.length > 0 &&
                            response.data.consentResults[0].consent === "PENDING") {
                            await SendConsent();
                        }
                        else {
                            hideTrip();
                            setTrip(TripDefault);
                            Alert.success(response.data.msg, {
                                position: 'bottom-right',
                                effect: 'slide',
                                html: false
                            });

                            setLoading(false);
                        }

                        await FetchTrips();
                        await AddTrackLogs(tripstart, response.data.tripId);
                        await setLoading(false);
                    }
                    else {
                        Alert.error(response.data.msg, {
                            position: 'bottom-right',
                            effect: 'slide',
                            html: false
                        });

                        setLoading(false);
                    }
                }).catch(function (error) {
                    Alert.error("Error Starting Trip.", {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });

                    setLoading(false);
                });

        }
    };

    const SendConsent = async () => {
        const token = await Buffer.from(`${auth.username}:${auth.password}`, 'utf8').toString('base64');

        await axios.get("https://sct.intutrack.com/api/" +
            ((process.env.REACT_APP_TRACK_ISPROD && process.env.REACT_APP_TRACK_ISPROD.toString() === "1") ? "prod" : "test") +
            "test/consents?tel=" + Trip.tel,
            {
                headers: {
                    'Authorization': `Basic ${token}`
                }
            }).then(async function (response) {
                if (response.data[0].code === 200) {
                    if (response.data[0].result.consent === "PENDING" &&
                        response.data[0].result.consent_suggestion.indexOf("Give a missed call") !== -1) {
                        setConsentInfo(response.data[0].result);
                        setdisplayConsent("block");
                    }

                    Alert.success("Trip Started", {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });

                    hideTrip();
                    setTrip(TripDefault);
                }
                else {
                    Alert.error(response.data.msg, {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });
                }
            }).catch(function (error) {
                Alert.error("Error Starting Trip.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            });

    };

    const AddTrackLogs = (tripsData, tripID) => {
        let tripdetails = tripsData;
        tripdetails.tripID = tripID;

        Axiosfetch(baseURL + "CreateTrackLogs", "POST", tripdetails, TrackLogSuccess, Failure);
    };

    const TrackLogSuccess = (data) => {
        setTrackingPartners("");
    };

    const FetchUsers = () => {
        FetchActivatedUsers(null, UserSuccess, Failure);
    };

    const UserSuccess = (data) => {
        let userlist = [];
        data.forEach(user => {
            if (user.Organization.length > 0 && ((user.ExpiryDate === undefined || user.ExpiryDate === null) ||
                (user.ExpiryDate !== "" && moment() < moment(user.ExpiryDate)))) {
                userlist.push({ value: user.Organization[0]._id, label: user.FirstName + " " + user.LastName + " [" + user.Organization[0].Name + "]" });
            }
        });

        setPartnerUsers(userlist);
    };

    const ValidateTrip = async () => {
        let enqErr = "";
        if (Trip.tel.trim() === "" || (Trip.tel.trim() !== "" && !/^[0-9]{10}$/.test(Trip.tel.trim().toString()))) {
            enqErr = "Please enter valid Telephone Number";
        }
        else if (Trip.srcname.trim() === "") {
            enqErr = "Please enter valid Origin City";
        }
        else if (Trip.destname.trim() === "") {
            enqErr = "Please enter valid Destination City";
        }
        else if (Trip.srcaddress.trim() === "") {
            enqErr = "Please enter valid Origin Pincode";
        }
        else if (Trip.destaddress.trim() === "") {
            enqErr = "Please enter valid Destination Pincode";
        }
        else if (isNaN(Trip.srcaddress.trim()) || Trip.srcaddress.trim() === "" || (Trip.srcaddress.trim() !== "" && !/^[1-9][0-9]{5}$/.test(Trip.srcaddress.trim().toString()))) {
            enqErr = "Please enter valid Source Pincode";
        }
        else if (isNaN(Trip.destaddress.trim()) || Trip.destaddress.trim() === "" || (Trip.destaddress.trim() !== "" && !/^[1-9][0-9]{5}$/.test(Trip.destaddress.trim().toString()))) {
            enqErr = "Please enter valid Destination Pincode";
        }
        else if (Trip.truck_number.trim() === "") {
            enqErr = "Please enter Truck Number";
        }
        else if (Trip.vendor.trim() === "") {
            enqErr = "Please enter Member Name";
        }
        else if (TrackingPartners !== "" && TrackingPartners.split(';').length > 2) {
            enqErr = "You can select maximum 2 Partners";
        }

        if (enqErr !== "") {
            Alert.error(enqErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const EndTrip = async (tripID) => {
        setLoading(true);
        const token = await Buffer.from(`${auth.username}:${auth.password}`, 'utf8').toString('base64');

        await axios.post("https://sct.intutrack.com/api/" + ((process.env.REACT_APP_TRACK_ISPROD && process.env.REACT_APP_TRACK_ISPROD.toString() === "1") ? "prod" : "test") + "/trips/end/" + tripID.toString(), { crossdomain: true },
            {
                headers: {
                    'Authorization': `Basic ${token}`
                }
            }).then(async function (response) {
                if (response.status === 200 && response.data.msg !== undefined) {
                    Alert.success(response.data.msg, {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });

                    await FetchTrips();
                    setLoading(false);
                }
                else {
                    Alert.error(response.data.msg, {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });
                    setLoading(false);
                }
            }).catch(function (error) {
                Alert.error("Error Ending Trip.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
                setLoading(false);
            });
    };

    const FetchTrips = async (running) => {
        setLoading(true);
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        const token = await Buffer.from(`${auth.username}:${auth.password}`, 'utf8').toString('base64');
        var isAdmin = (userData && userData.Role !== undefined && userData.Role.length > 0) ? userData.Role[0].Name.toUpperCase() === "ADMIN" : false;

        await axios.get("https://sct.intutrack.com/api/" + ((process.env.REACT_APP_TRACK_ISPROD && process.env.REACT_APP_TRACK_ISPROD.toString() === "1") ? "prod" : "test") + "/trips" + (running !== undefined && running === "1" ? "?running=true" : ""),
            {
                headers: {
                    'Authorization': `Basic ${token}`
                }
            }).then(async function (response) {
                if (response.status === 200) {
                    var tripInfoData = [];
                    response.data.forEach(trip => {
                        if (isAdmin || (trip.custom_Org !== undefined && trip.custom_Org !== null &&
                            trip.custom_Org.toString().indexOf(userData.Organization[0]._id) !== -1)) {

                            tripInfoData.push({
                                Id: trip._id,
                                sourceName: trip.srcname,
                                destname: trip.destname,
                                truck_number: trip.truck_number,
                                srcaddress: trip.srcaddress,
                                destaddress: trip.destaddress,
                                TelePhone: trip.tel.length > 0 ? trip.tel[0] : "",
                                invoice: trip.invoice,
                                LR: trip.lr_number,
                                endTime: trip.endTime,
                                CreatedDate: trip.createdAt,
                                status: trip.status,
                            });
                        }
                    });

                    setTripsInfo(tripInfoData);
                    setLoading(false);
                }
            }).catch(function (error) {
                Alert.error("Error loading Tracking Details. Check Internet Connection", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
                setLoading(false);
            });
    };

    const setInvoiceIDCriteria = (Invoice) => {
        if (Invoice !== null) {
            let surveyID = Invoice.value;
            var SurveyToGenerate = InvoicesData.filter(q => q._id === surveyID);
            if (SurveyToGenerate.length > 0) {
                var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
                setTrip({
                    tel: "",
                    eta_days: 0,
                    srcname: SurveyToGenerate[0].OriginCity,
                    destname: SurveyToGenerate[0].DestinationCity,
                    srcaddress: SurveyToGenerate[0].OriginPincode,
                    destaddress: SurveyToGenerate[0].DestinationPincode,
                    vendor: (userData !== null && userData.Organization && userData.Organization.length > 0) ? "MFI " + userData.Organization[0].City : "",
                    truck_number: "",
                    invoice: Invoice.label,
                    custom_Org: ""
                });
            }
        }
        else {
            setTrip({ ...Trip, "invoice": "" })
        }
    };

    const UpdateTrip = async () => {
        setLoading(true);
        const token = await Buffer.from(`${auth.username}:${auth.password}`, 'utf8').toString('base64');
        await axios.put("https://sct.intutrack.com/api/" + ((process.env.REACT_APP_TRACK_ISPROD && process.env.REACT_APP_TRACK_ISPROD.toString() === "1") ? "prod" : "test")
            + "/trips", { _id: SelectedTrip, tel: UpdateTel },
            {
                headers: {
                    'crossdomain': true,
                    'Authorization': `Basic ${token}`
                }
            }).then(async function (response) {
                if (response.status === 200 && response.data.msg !== undefined) {
                    Alert.success(response.data.msg, {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });

                    hideUpdateTrip();
                    await FetchTrips();
                    setLoading(false);
                }
                else {
                    Alert.error(response.data.msg, {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });
                    setLoading(false);
                }
            }).catch(function (error) {
                Alert.error("Error Updating Trip.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
                setLoading(false);
            });
    };

    const OnUserChange = (data) => {
        if (data && data.length <= 2) {
            var users = "";
            data.forEach(data => {
                users += `${data.value};`
            });

            users = users !== "" ? users.substring(0, users.length - 1) : "";
            setTrackingPartners(users);
        }
        else {
            Alert.error("Maximum 2 partners are allowed to be selected", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const FetchRunningTrips = () => {
        FetchTrips("1");
    };

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    {Loading && (<Loader></Loader>)}
                    <div className="col-md-1 col-sm-1 col-2 align-center trackheader">
                        <span style={{ fontSize: "22px", paddingRight: "20px" }} data-tip="Mobile Operator Info"
                            onClick={DisplayOperatorInfo} className={`cursorpointer ${CurrentTheme}Color`}>
                            {/* <FontAwesomeIcon icon={faMobileAlt} /> */}
                            <img alt="track" src={PhoneRing} width="40" height="40"></img>
                        </span>

                    </div>
                    <div className="col-md-6 col-sm-6 col-10 align-right trackheader">
                        <div style={{ fontWeight: "500", fontSize: "28px" }}>Manage Trip</div>
                    </div>
                    <div className="col-md-5 col-sm-5 col-12 align-right buttonresponsive">
                        <span style={{ fontSize: "22px", paddingRight: "20px" }} data-tip="All Running Trips" onClick={FetchRunningTrips} className={`cursorpointer ${CurrentTheme}Color`}><FontAwesomeIcon icon={faRunning} /></span>
                        <span style={{ fontSize: "22px", paddingRight: "20px" }} data-tip="Load All Trips" onClick={FetchTrips} className={`cursorpointer ${CurrentTheme}Color`}><FontAwesomeIcon icon={faSyncAlt} /></span>
                        <span style={{ fontSize: "25px" }} onClick={showTrip} data-tip="Add Trip" className={`cursorpointer ${CurrentTheme}Color`}><FontAwesomeIcon icon={faPlusCircle} /></span>
                    </div>


                    <div style={{ width: "100%", textAlign: "center", border: (TripsInfo.length !== 0 ? "1px solid #ccc" : "none"), borderRadius: "10px" }}>
                        {TripsInfo.length > 0 && (<DataTable columns={columns} data={TripsInfo}></DataTable>)}
                        {
                            TripsInfo.length === 0 && (<div style={{ position: "relative", top: "20%" }} className="textCenter">
                                <span><FontAwesomeIcon icon={faRunning} /></span> Click to Load Running Trips.
                                <span style={{ marginLeft: "10px" }}><FontAwesomeIcon icon={faSyncAlt} /></span> Click to Load All Trips
                                <span style={{ marginLeft: "10px" }}><FontAwesomeIcon icon={faPlusCircle} /></span> Click  to Add new Trip.
                            </div>)
                        }
                    </div>
                    <div className="col-md-12" style={{ width: "100vw", wordBreak: "break-word", color: "red", textAlign: "center" }}>
                        <span style={{ fontWeight: "bold" }}>Note :</span> Based on the Mobile operator you have to either reply to the message send to registered mobile number or give missed call (for new mobile user only).
                    </div>
                </div>
            </div>
            <div id="myModal3" className="modal" style={{ display: displayAddTrip }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Add Trip</span>
                        <span className="close" onClick={hideTrip}>&times;</span>
                    </div>
                    <div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td style={{ width: "50%" }}>
                                        <div className="text-field" style={{ margin: "0" }}>
                                            <input autoFocus placeholder="" name="tel" value={Trip.tel ? Trip.tel : ""}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Enter Device/Phone<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td style={{ width: "50%" }}>
                                        <div className="text-field" style={{ margin: "0" }}>
                                            <input placeholder="" name="eta_days" value={Trip.eta_days ? Number(Trip.eta_days).toString() : ""}
                                                onChange={(e) => onNumberChange(e)}
                                                type="text"></input>
                                            <span>Delivery Days</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-field" style={{ margin: "0" }}>
                                            <input style={{ resize: "none" }} placeholder="" name="srcname" value={Trip.srcname}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Origin City<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field" style={{ margin: "0" }}>
                                            <input style={{ resize: "none" }} placeholder="" name="destname" value={Trip.destname}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Destination City<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-field" style={{ margin: "0" }}>
                                            <input style={{ resize: "none" }} placeholder="" name="srcaddress" value={Trip.srcaddress}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Origin Pincode<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field" style={{ margin: "0" }}>
                                            <input style={{ resize: "none" }} placeholder="" name="destaddress" value={Trip.destaddress}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Destination Pincode<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
                                            <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Booking ID"
                                                options={InvoicesInfo}
                                                onChange={setInvoiceIDCriteria}></Select>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field" style={{ margin: "0" }}>
                                            <input placeholder="" name="truck_number" value={Trip.truck_number}
                                                onChange={(e) => onTruckTextChange(e)}
                                                type="text"></input>
                                            <span>Truck Number<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-field" style={{ margin: "0" }}>
                                            <input readOnly placeholder="" name="vendor" value={Trip.vendor ? Trip.vendor : ""}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Member</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Partner"
                                                options={PartnerUsers} isMulti
                                                onChange={OnUserChange}></Select>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="2">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={StartTrip}>Submit</button>
                                                <button type="button" className="btn btn-default" onClick={hideTrip}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div id="myModal3" className="modal" style={{ display: displayUpdateTrip }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Update Trip</span>
                        <span className="close" onClick={hideUpdateTrip}>&times;</span>
                    </div>
                    <div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="text-field">
                                            <input autoFocus placeholder="" value={UpdateTel}
                                                onChange={(e) => onUpdateTripChange(e)}
                                                type="text"></input>
                                            <span>Enter Device/Phone<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="2">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={UpdateTrip}>Submit</button>
                                                <button type="button" className="btn btn-default" onClick={hideUpdateTrip}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div id="myModalConsent" className="modal" style={{ display: displayConsent }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Consent Info</span>
                        <span className="close" onClick={hideConsent}>&times;</span>
                    </div>
                    <div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        consent
                                    </td>
                                    <td>{ConsentInfo.consent}</td>
                                </tr>
                                <tr>
                                    <td>
                                        Suggestion
                                    </td>
                                    <td>{ConsentInfo.consent_suggestion}</td>
                                </tr>
                                <tr>
                                    <td>
                                        Message
                                    </td>
                                    <td>{ConsentInfo.message}</td>
                                </tr>
                                <tr>
                                    <td>
                                        Number
                                    </td>
                                    <td>{ConsentInfo.number}</td>
                                </tr>
                                <tr>
                                    <td>
                                        Operator
                                    </td>
                                    <td>{ConsentInfo.operator}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div id="myModalMobileAlert" className="modal" style={{ display: displayMobileAlert }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Mobile Alert Info</span>
                        <span className="close" onClick={hideMobileAlert}>&times;</span>
                    </div>
                    <div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h5 style={{ color: "red" }}>Notice : As tracking involves taking consent of the number which needs to be tracked during the trips, consent procedure is as follows</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5> 1. <span style={{ fontWeight: "600" }}>Airtel</span> : Call 7428498641. After calling, press "1" to complete the consent.</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>2. <span style={{ fontWeight: "600" }}>Jio</span> : Reply “Y” to message received from 51712022(Toll Free).</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>3. <span style={{ fontWeight: "600" }}>Vodafone</span> : Call 7428498641. After calling, press "1" to complete the consent.</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>4. <span style={{ fontWeight: "600" }}>Idea</span> : Call 7428498641. After calling, press "1" to complete the consent.</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>5. <span style={{ fontWeight: "600" }}>BSNL</span> : Call 7428498641. After calling, press "1" to complete the consent.</h5>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageTrip;